import axios from "axios"
import { AMS_API_URL, USER_STORAGE_NAME } from "./constants"

export const apiAMS = axios.create({
	baseURL: AMS_API_URL,
	headers: {
		"Content-Type": "application/json",
	},
	withCredentials: true,
})

apiAMS.interceptors.request.use(req => {
	req.headers["mode"] = window.__DF_MODE
	return req
})

apiAMS.interceptors.response.use(
	response => response,
	async error => {
		const originalRequest = error.config
		const isLoginApi = originalRequest.url.includes("/auth/login")
		const isExtendApi = originalRequest.url.includes("/auth/extend")

		const redirectToLogin = () => {
			localStorage.removeItem(USER_STORAGE_NAME)
			const nextUrl = ["/login", "/", "/test/login"].includes(
				window.location.pathname,
			)
				? "/dashboard"
				: window.location.pathname
			if (window.__DF_MODE === "PROD") {
				window.location.href = `/login?nextUrl=${nextUrl}`
			} else {
				window.location.href = `/test/login?nextUrl=${nextUrl}`
			}
			// TODO : after sucessfull login redirect to the original request
		}

		if (!originalRequest._retryCount) {
			originalRequest._retryCount = 0
		}

		if (
			!isLoginApi &&
			!isExtendApi &&
			error.response.status === 401 &&
			originalRequest._retryCount < 5
		) {
			try {
				const response = await apiAMS.post("/auth/extend")
				if (response.status == 200) return apiAMS(originalRequest)
			} catch (err) {
				console.log(err)
				redirectToLogin()
			}
		}

		if (error.response.status === 401 && !isLoginApi) redirectToLogin()

		return Promise.reject(error)
	},
)
